import { dom } from '@fortawesome/fontawesome-svg-core'
  ; (async () => {
    const { default: moment } = await import('moment')

    Promise.all([
      import('../../plugins/semantic/form'),
      import('../../plugins/semantic/form.scss'),
      import('../guest-selector/guest-selector'),
      import('../guest-selector/guest-selector.scss'),
    ]).then(() => {
      Promise.all([
        import('../../scripts/dbs/dbs.semantic.form'),
        import('../../plugins/semantic/input.scss'),
        import('../../plugins/semantic/label.css'),
        import('../../plugins/semantic/transition.css'),
        import('../../plugins/semantic/transition.js'),
        import('../../plugins/semantic/icon.css'),
        import('../../plugins/semantic/modal.scss'),
        import('../../plugins/semantic/popup.css'),
        import('../../plugins/semantic/dropdown.scss'),
        import('../../plugins/semantic/dropdown'),
        import('../../plugins/semantic/modal'),
        import('../../plugins/semantic/dimmer.scss'),
        import('../../plugins/semantic/dimmer'),
        import('../../plugins/daterangepicker/daterangepicker'),
        import('../../plugins/daterangepicker/daterangepicker.scss'),
        import('../../scripts/dbs/dbs.utilities.geolocation'),
        import('../../scripts/dbs/dbs.utilities.querystring'),
        import('../../plugins/semantic/search'),
        import('../../plugins/semantic/search.scss'),
        import('../../plugins/semantic/api'),
        import(/* webpackMode: "eager" */ './accommodation-block.scss'),
      ]).then(() => {
        $('.widget.accommodation-block').each(function (i, el) {
          $(el).data('widget', new AccommodationBlockSearch(el, moment))
          $(el).data('widget').init()
        })
      })
    })
  })()

function AccommodationBlockSearch(el, moment) {
  const self = this
  self.el = $(el)
  self.paginationContainer = self.el.find('.js-pagination-container')

  self.propertyCode = self.el.attr('data-propertyCode')
  self.parkCutoffEndpoint = self.el.attr('data-search-top-park-room-cutoff')
  self.parkCutoffEndpointMethod = 'GET'
  self.getAccommodationEndpoint = self.el.attr('data-search-top-park-rooms')
  self.getAccommodationEndpointMethod = self.el.attr('data-method')
  self.getAccommodationAvailableDatesEndpoint = self.el.attr('data-search-top-park-rooms-availabledates')
  self.getAccommodationAvailableDatesEndpointMethod = self.el.attr('data-method')

  self.dateSelector = self.el.find('.filters .date-selector')
  self.sortByDropdown = self.el.find('.sort-container .ui.dropdown')

  self.arriveInput = self.el.find('.arrive.input')
  self.departInput = self.el.find('.depart.input')
  self.adultsInput = self.el.find('.adults.input')
  self.kidsInput = self.el.find('.kids.input')
  self.infantsInput = self.el.find('.infants.input')
  self.adultsShownValue = self.el.find('.adults.value')
  self.infantsShownValue = self.el.find('.infants.value')
  self.kidsShownValue = self.el.find('.kids.value')
  self.totalGuestsValue = self.el.find('.total-guests-value')
  self.totalGuestsInput = self.el.find('.total.guests.input')

  self.accommodationTypeInput = self.el.find('.accommodation-type.input')
  self.sortByInput = self.el.find('.sort-container input[type="hidden"]')
  self.maxSearchResults = self.el.find('.maxSearchResults.input')
  const sortFilterIcon = self.el.find('.sort-container div.icon')

  self.today = new Date()
  self.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  self.dayAfterTomorrow = new Date(new Date().setDate(new Date().getDate() + 2))
  self.maxDate = new moment().add(1, 'y').toDate()

  self.qs = new dbs.utilities.querystring()
  self.isMobile = $('body').hasClass('is-mobile-view')

  window.dbs.globalEvents.subscribe('update_selected_dates', function (payload) {

    if (process.env.NODE_ENV === 'development') {
      console.log('emitDateSelectorDates', payload)
    }

    setDateSelectorDates(payload.dataFrom, payload.dataTo)
    //update the selected dates in calendar
    self.dateSelector.data('daterangepicker').setStartDate(moment(payload.dataFrom).format('YYYY-MM-DD'))
    self.dateSelector.data('daterangepicker').setEndDate(moment(payload.dataTo).format('YYYY-MM-DD'))

    // For 'not available' result items, if user selects available dates using the calendar to pick dates available for this item,
    // we perform a new search and this 'not available' result item will be moved into the 'available' results. As such, we want
    // to pass the room code to focus (scroll to) this item when the new search results are returned.
    self.search({
      //focusRoomCode: parentEl.parent().hasClass('results-unavailable') && roomCode,
      focusRoomCode: payload.roomCode, //unvailable AND available items will be scrolled into view
    })
  })

  self.setVideoSource = function () {
    // Find all video elements in the widget
    const videoEls = self.el.find('video')
    if (videoEls.length === 0) return

    // Set the video source based on the screen size
    const isMobile = window.innerWidth < 640
    const isTablet = window.innerWidth >= 640 && window.innerWidth < 1024
    videoEls.each(function (i, el) {
      const videoEl = $(el)

      // Video soruces
      const mobileSrc = videoEl.attr('data-src-mobile')
      const tabletSrc = videoEl.attr('data-src-tablet')
      const desktopSrc = videoEl.attr('data-src-desktop')

      // Poster sources
      const mobilePoster = videoEl.attr('data-poster-mobile')
      const tabletPoster = videoEl.attr('data-poster-tablet')
      const desktopPoster = videoEl.attr('data-poster-desktop')

      // Set video src
      let src = desktopSrc // default
      if (isMobile && (mobileSrc || tabletSrc)) {
        src = mobileSrc || tabletSrc
      } else if (isTablet && tabletSrc) {
        src = tabletSrc
      }

      // Select poster image
      let poster = desktopPoster // default
      if (isMobile && (mobilePoster || tabletPoster)) {
        poster = mobilePoster || tabletPoster
      } else if (isTablet && tabletPoster) {
        poster = tabletPoster
      }

      if (src) {
        videoEl.attr('src', src)
        if (poster) videoEl.attr('poster', poster)
        videoEl.attr('muted', true) // NOTE: Muted is required for autoplay to work on mobile
        videoEl.attr('autoplay', true)
        videoEl.attr('playsinline', true)
        videoEl[0].load()
      }
    })
  }

  self.bindEvents = function () { }

  self.initFiltersForm = function () {
    initDateSelectorCalendar()
    initGuestSelectorFilter()
    initParkTypesFilter()
  }

  function getInitialDateSelectorDates() {
    function getDayAfterDate(date) {
      return moment(new Date(new Date(date).setDate(new Date(date).getDate() + 1))).format('YYYY-MM-DD')
    }

    return new Promise((resolve) => {
      let arrive, depart
      let paramArrive = self.qs.getParameter('arrive')
      let paramDepart = self.qs.getParameter('depart')

      if (paramArrive) {
        arrive = paramArrive
        depart = paramDepart ?? getDayAfterDate(paramArrive)
      } else {
        $.ajax({
          url: self.parkCutoffEndpoint + `?code=${self.propertyCode}`,
          type: 'GET',
          dataType: 'json',
          async: false,
          contentType: 'application/json',
        })
          .done(function (isPastParkCutoff) {
            arrive = isPastParkCutoff ? self.tomorrow : self.today
            depart = isPastParkCutoff ? self.dayAfterTomorrow : self.tomorrow
          })
          .fail(function () {
            arrive = self.today
            depart = self.tomorrow
          })
      }

      const dates = {
        arrive: moment(arrive).format('YYYY-MM-DD'),
        depart: moment(depart).format('YYYY-MM-DD'),
      }

      resolve(dates)
    })
  }

  function getAvailableDates() {
    const params = new URLSearchParams(window.location.search)

    let data = {
      propertyCode: self.propertyCode,
      arrive: self.dateSelector.find('.arrive.input').val(),
      depart: self.dateSelector.find('.depart.input').val(),
      adults: params.get('adults') ?? 2,
      kids: params.get('kids') ?? 0,
      infants: params.get('infants') ?? 0,
      accommodationType: params.get('accommodationType') ?? '',
      sort: params.get('sort') ?? 'price_desc',
      roomCodes: [],
    }

    const dealCode = params.get('dealCode')
    if (dealCode) {
      data.dealCode = dealCode
    }
    return $.ajax({
      url: self.getAccommodationAvailableDatesEndpoint,
      type: self.getAccommodationAvailableDatesEndpointMethod,
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
  }

  async function initDateSelectorCalendar() {
    const initialDates = await getInitialDateSelectorDates()

    setDateSelectorDates(initialDates.arrive, initialDates.depart)

    let availableDates = undefined

    if ($(el).attr('data-brand') === 'gdayparks') {
      availableDates = await getAvailableDates()

      // Format dates to 'YYYY-MM-DD'
      availableDates = availableDates?.Dates?.map((date) => date.substring(0, 10))
    }

    // See: https://www.daterangepicker.com/#options
    self.dateSelector.daterangepicker(
      {
        autoApply: true,
        startDate: initialDates.arrive,
        endDate: initialDates.depart,
        minDate: self.today,
        maxDate: self.maxDate,
        parentEl: self.dateSelector.parent(),
        locale: {
          format: 'YYYY-MM-DD',
        },
        isInvalidDate: function (date) {
          // NOTE `return true` will mark the date as invalid.
          if (availableDates === undefined) return false

          // If there ares no available dates, and we are showing a message, then `return false` to unlock the calendar
          if (availableDates.length == 0 && self.el.find('#accommodation-availability-message')) return false

          return !availableDates.includes(moment(date).format('YYYY-MM-DD'))
        },
      },
      function (startDate, endDate) {
        let start = moment(startDate);
        let end = moment(endDate);
        if (startDate.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')) {
          debugger;
          endDate = end.add(1, 'days');
        }
        // Check if it's > 28 nights, reset it to 28 nights if it's > 28 nights
        const nightsCount = end.diff(start, 'days');

        if (nightsCount > 28) {
          setDateSelectorDates(startDate, endDate) // Update to 28 days
          self.search()
          endDate = start.clone().add(28, 'days').format('YYYY-MM-DD');
          // Update the selection as well
          window.setTimeout(function () {
            setDateSelectorDates(startDate, endDate) // Update to 28 days
            self.dateSelector.data('daterangepicker').setStartDate(startDate)
            self.dateSelector.data('daterangepicker').setEndDate(endDate)
          }, 500)
          return;
        } else {
          setDateSelectorDates(startDate, endDate)
          self.dateSelector.data('daterangepicker').setStartDate(startDate)
          self.dateSelector.data('daterangepicker').setEndDate(endDate)
          self.search()
        }
      },
    )

    self.dateSelector.on('show.daterangepicker hide.daterangepicker', function (event, picker) {
      if (event.type === 'show') {
        picker.element.addClass('open')

        // Close all 'view availability' pickers
        // https://discoveryparks.atlassian.net/browse/HPR-343
        $('.calendar-trigger')
          .not($(this))
          .each(function () {
            const picker = $(this).data('daterangepicker')
            if (picker && picker.isShowing) {
              picker.hide()
            }
          })
      } else {
        picker.element.removeClass('open')
      }
    })
  }

  function initGuestSelectorFilter() {
    // NOTE dates selector is handled in another function
    window.dbs.globalEvents.subscribe('guestselector:updated', function () {
      self.search()
    })
  }

  function initParkTypesFilter() {
    self.el.find('.park-types a').click(function (event) {
      event.preventDefault()
      let parkType = $(this).attr('data-type')
      setParkTypeFilter(parkType)
      self.search()
    })

    // Set initial value
    let accommodationTypeParam = self.qs.getParameter('accommodationType')
    if (accommodationTypeParam) {
      setParkTypeFilter(accommodationTypeParam.toLowerCase())
    }
  }

  function initSortByFilter() {
    // Init dropdown so we can set initial value
    self.sortByDropdown.dropdown({ placeholder: false })

    // Set initial value
    let sortParam = self.qs.getParameter('sort')
    if (sortParam) {
      setSortByFilter(sortParam, true)
    }

    // Now initial value is set, re-init dropdown with `onChange` callback
    self.sortByDropdown.dropdown({
      placeholder: false,
      onChange: function () {
        self.search()
        $('.dropdown-text > div').html(self.sortByDropdown.dropdown('get text'))
      },
    })
  }

  function setDateSelectorDates(dateFrom, dateTo) {
    if (process.env.NODE_ENV === 'development') {
      console.log('setDateSelectorDates', dateFrom, dateTo)
    }

    self.dateSelector
      .find('.date-range-picker')
      .removeClass('empty')
      .text(moment(dateFrom).format('DD MMM') + ' – ' + moment(dateTo).format('DD MMM'))

    self.arriveInput.val(moment(dateFrom).format('YYYY-MM-DD'))
    self.departInput.val(moment(dateTo).format('YYYY-MM-DD'))
  }

  function setParkTypeFilter(parkType) {
    const button = self.el.find(`.park-types a[data-type=${parkType}]`)

    // Toggle off or between filter types
    if ($(button).hasClass('active')) {
      $(button).removeClass('active')
      self.el.find('.accommodation-type.input').val('')
    } else {
      $(button).addClass('active').siblings().removeClass('active')
      self.el.find('.accommodation-type.input').val(parkType)
    }
  }

  function setSortByFilter(sortBy) {
    if (process.env.NODE_ENV === 'development') {
      console.log(sortBy)
    }
    self.sortByDropdown.dropdown('set selected', sortBy)
  }

  function getFilterValues() {
    let filters = {
      propertyCode: self.propertyCode,
      arrive: self.arriveInput.val(),
      depart: self.departInput.val(),
      adults: self.adultsInput.val(),
      kids: self.kidsInput.val(),
      infants: self.infantsInput.val(),
      accommodationType: self.accommodationTypeInput.val(),
      sort: self.sortByInput.val(),
      maxSearchResults: self.qs.getParameter('maxSearchResults') ?? self.maxSearchResults.val(),
      index: self.qs.getParameter('index'),
    }

    // NOTE Only add `dealCode` property if we have a value.
    const dealCode = self.qs.getParameter('dealCode')
    if (dealCode) {
      filters.dealCode = dealCode
    }

    var urlForParam = new URL(window.location.href)
    urlForParam.searchParams.forEach((val, key) => {
      // Add a Property
      if (!filters.hasOwnProperty(key)) {
        Object.defineProperty(filters, key, {
          value: self.qs.getParameter(key),
          writable: true,
          configurable: true,
          enumerable: true,
        })
      }
    })

    return filters
  }

  function getPropertiesDataByRoomCode(roomCode) {
    if (!roomCode) return

    const data = {
      roomCodes: [roomCode],
      propertyCode: self.propertyCode,
      arrive: self.filters.arrive,
      depart: self.filters.depart,
      adults: self.filters.adults,
      kids: self.filters.kids,
      infants: self.filters.infants,
      accommodationType: self.filters.accommodationType,
    }

    return $.ajax({
      url: $(el).attr('data-search-top-park-room'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
  }

  /**
   * Checks to see if the element bottom falls out of view, and scrolls into view if true. Determines what layout
   * is displaying (stacked, or two column) using `matchMedia` then compares the element bottom against the
   * relevant parent scrolling element bottom (window or results wrapper) and scrolling to ensure the element is
   * fully in view.
   * @param el - jQuery DOM element
   */
  function scrollElBottomIntoView(el) {
    const elBottom = el[0].getBoundingClientRect().bottom

    // If two column layout, else stacked layout
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    if (mediaQuery.matches) {
      const overflowDistance = elBottom - resultsWrapper[0].getBoundingClientRect().bottom
      if (overflowDistance > 0) {
        resultsWrapper[0].scrollBy({
          top: overflowDistance,
          behavior: 'smooth',
        })
      }
    } else {
      const overflowDistance = elBottom - window.innerHeight
      if (overflowDistance > 0) {
        window.scrollBy({
          top: overflowDistance,
          behavior: 'smooth',
        })
      }
    }
  }

  self.pushState = function (filters) {
    // Filter out empty values, considering falsely values
    let stateFilters = Object.fromEntries(Object.entries(filters).filter(([, value]) => value === 0 || !!value))

    // Preserve existing hash when updating URL params
    const currentHash = window.location.hash || ''
    const newUrl = window.location.pathname + '?' + $.param(stateFilters) + currentHash

    // Update URL params with new filter values, but do not reload the page.
    history.replaceState({ filters: stateFilters }, '', newUrl)
  }

  let foo = 1

  self.search = function ({ focusRoomCode } = {}) {
    if (process.env.NODE_ENV === 'development') {
      console.log('HeroBannerBlock search')
    }

    self.el.addClass('loading')

    // Emit 'disable' of controls (used by 'guest-selector' widget)
    window.dbs.globalEvents.emit('disableControls')

    self.filters = getFilterValues()

    self.pushState(self.filters)

    const data = {
      ...self.filters,
    }

    const url = self.getAccommodationEndpoint

    // send filters to ajax
    $.ajax({
      url,
      type: self.getAccommodationEndpointMethod,
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        if (process.env.NODE_ENV === 'development') {
          console.log('HeroBannerBlock search done', data)
        }

        // CW-8299 [view_item_list] Accommodation listing
        ; (function () {
          if (data.ParkDataLayer) {
            const dataLayerAsJson = JSON.parse(data.ParkDataLayer)
            // TODO verify data layer object
            // Remove not required fields
            delete dataLayerAsJson.park_name
            delete dataLayerAsJson.park_id
            delete dataLayerAsJson.region
            delete dataLayerAsJson.state
            delete dataLayerAsJson.amenities
            // if (process.env.NODE_ENV === 'development') {
            //   console.log(`CW-8299 event ${dataLayerAsJson.event}`, JSON.stringify(dataLayerAsJson, null, 2))
            // }
            window.dataLayer = window.dataLayer || [] // Create a data layer
            dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object
            dataLayer.push(dataLayerAsJson)
          }
        })()

        // Handle 'deal code' removal
        let shouldRemoveDeal = data[Object.keys(data).find((key) => key.match(/^removedeal$/i))]
        //if (shouldRemoveDeal && self.qs.getParameter('dealcode')) {
        //window.location.href = self.qs.removeParameter('dealcode', window.location.href)
        //}
        if (shouldRemoveDeal && self.qs.getParameter('dealcode')) {
          // Don't reload, just remove from URL parameters, then re-search
          self.filters.dealCode = ''
          self.pushState(self.filters)
          self.search()
          return
        }

        // Handle 'dates' state
        if (self.filters.arrive !== data.From || self.filters.depart !== data.To) {
          setDateSelectorDates(data.From, data.To)
          self.dateSelector.data('daterangepicker').setStartDate(moment(data.From).format('YYYY-MM-DD'))
          self.dateSelector.data('daterangepicker').setEndDate(moment(data.To).format('YYYY-MM-DD'))

          // Push new state
          self.filters = getFilterValues()
          self.pushState(self.filters)
        }

        // Emit 'available deals' data
        window.dbs.globalEvents.emit('deals_updated', { AvailableDeals: data.AvailableDeals }, true)

        window.dbs.globalEvents.emit('RenderProperties', {
          data: data,
          filters: self.filters,
          focusRoomCode: focusRoomCode,
        })

        // Emit 'enable' of controls (used by 'guest-selector' widget)
        window.dbs.globalEvents.emit('enableControls')

        if (focusRoomCode) {
          // TODO? Are we doing any scrolling for the new Figma design?
        }
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
      .always(function () {
        // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
        dom.i2svg()

        self.el.removeClass('loading')
      })
  }

  self.init = async function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('HeroBannerBlock init', self)
    }
    self.el.css('opacity', 1)

    // NOTE 'calendar-price-tooltip' CSS class can be found in result items calendar popup.
    $('body').on('click mouseenter', '.calendar-price-tooltip', function () {
      const classes = $(this).attr('class').split(' ')

      for (let i = 0; i < classes.length; i++) {
        const class1 = classes[i]
        if (class1.indexOf('price') !== -1) {
          $(this).attr('data-tooltip', '$' + class1.split('_')[1])
        }
      }
    })

    $('.pt-park-detail').on('click', 'a.more-info', function (e) {
      // Data from HTML
      const $clicked = $(e.currentTarget)
      const container = $clicked.closest('.item--dhp')
      const index = container.data('index')
      const price = container.find('.price span').text()
      const roomType = container.find('.type').text()

      // Query string data
      const totalGuests =
        parseInt(self.qs.getParameter('adults')) +
        parseInt(self.qs.getParameter('kids')) +
        parseInt(self.qs.getParameter('infants'))
      const checkIn = self.qs.getParameter('arrive')
      const checkOut = self.qs.getParameter('depart')
      const lengthOfStay = Math.ceil((new Date(checkOut) - new Date(checkIn)) / (1000 * 3600 * 24))

      const data = $('#pt-park-data').data('ga4')
      const stateMap = {
        SA: 'South Australia',
        NSW: 'New South Wales',
        QLD: 'Queensland',
        VIC: 'Victoria',
        WA: 'Western Australia',
        TAS: 'Tasmania',
        NT: 'Northern Territory',
        ACT: 'Australian Capital Territory',
      }
      const parkState = stateMap[data.ParkPostalAddressStateCode]
      let parkName = data.ParkDisplayName
      if (data.ParkDisplayName.includes('Discovery Parks')) {
        parkName = data.ParkDisplayName.replace('Discovery Parks - ', '')
      }
      const parkAddress =
        data.ParkAddressStreet +
        ', ' +
        data.ParkAddressTown +
        ', ' +
        data.ParkPostalAddressStateCode +
        ' ' +
        data.ParkAddressPostCode

      var parkBrand = "G'day Parks"
      // If being booked on Discovery Parks, or is a Discovery Park being booked on G'day Parks
      if ($('html').hasClass('dhp-theme') || data.ParkDisplayName.includes('Discovery Parks')) {
        parkBrand = 'Discovery Parks'
      }
      window.dataLayer = window.dataLayer || [] // Create a data layer
      window.dataLayer.push({ ecommerce: null }) // Clear the previous objects
      let eventData = {
        item_id: data.ParkCrmCode,
        item_name: parkName,
        item_brand: parkBrand,
        index: index, // index is the position in the list of rooms
        item_category: roomType,
        item_category2: data.ParkAddressTown,
        item_category3: 'Non Member', // Always will be a non member until account creation has been completed
        item_category4: '', // Empty on purpose
        item_category5: parkState,
        item_variant: totalGuests,
        location_id: parkAddress,
        price: price,
        quantity: lengthOfStay,
        item_start_date: checkIn,
        item_end_date: checkOut,
        item_list_name: parkName,
      }
      dataLayer.push({
        event: 'select_item',
        ecommerce: {
          items: [eventData],
        },
      })
    })

    window.dbs.globalEvents.subscribe('update_k13_accommodation_widget', (data) => {
      if (!data.hasOwnProperty('bookingContext')) {
        if (process.env.NODE_ENV === 'development') {
          console.log('No booking context found when updating accommodation widget')
        }
        return
      }
      let newFilters = {}
      newFilters.arrive = moment(data.bookingContext.checkIn).format('YYYY-MM-DD')
      newFilters.depart = moment(data.bookingContext.checkOut).format('YYYY-MM-DD')
      newFilters.adults = parseInt(data?.bookingContext.adults) ?? 2
      newFilters.kids = parseInt(data?.bookingContext.children) ?? 0
      newFilters.infants = parseInt(data.bookingContext.infants) ?? 0
      if (data.bookingContext.hasOwnProperty('appliedDealId')) {
        if (data.bookingContext.appliedDealId != '') {
          newFilters.dealCode = data.bookingContext.appliedDealId
        }
      }
      // Check if anything has actually changed to avoid unneccessary API calls
      if (
        newFilters.arrive != self.filters.arrive ||
        newFilters.depart != self.filters.depart ||
        newFilters.adults != self.filters.adults ||
        newFilters.kids != self.filters.kids ||
        newFilters.infants != self.filters.infants
      ) {
        if (newFilters.arrive != self.filters.arrive || newFilters.depart != self.filters.depart) {
          setDateSelectorDates(newFilters.arrive, newFilters.depart)
          //update the selected dates in calendar
          self.dateSelector.data('daterangepicker').setStartDate(moment(newFilters.arrive).format('YYYY-MM-DD'))
          self.dateSelector.data('daterangepicker').setEndDate(moment(newFilters.depart).format('YYYY-MM-DD'))
        }
        let emitGuestUpdate = false
        if (newFilters.adults != self.filters.adults) {
          //self.adultsInput.val(newFilters.adults);
          emitGuestUpdate = true
        }
        if (newFilters.kids != self.filters.kids) {
          //self.kidsInput.val(newFilters.kids);
          emitGuestUpdate = true
        }
        if (newFilters.infants != self.filters.infants) {
          //self.infantsInput.val(newFilters.infants);
          emitGuestUpdate = true
        }

        // update total guests if guests amount has changed
        self.filters = newFilters
        self.pushState(self.filters)
        if (emitGuestUpdate) {
          window.dbs.globalEvents.emit('search_popstate', { filters: self.filters })
        }
        self.search()
      }
    })

    await self.initFiltersForm()
    self.bindEvents()
    self.search()
  }

  sortFilterIcon.click(function () {
    $('.sort-container div.dropdown').click()
  })
}
